<template>
    <div class="bottom-banner2_ext" />
</template>
<script>
export default {};
</script>
